module.exports = __webpack_public_path__ + "img/green-booth-table-6.6d272d86.png";